import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import AuthContext from '../shared/AuthContext';
import { resolveFeatureForPath } from '../../config/planFeatures';
import { useUserPlan } from '../../hooks/useUserPlan';
import PlanUpgradeNotice from './PlanUpgradeNotice';

/**
 * Blocks entire route trees when the signed-in user's plan is insufficient.
 */
export default function PlanPathGuard({ children }) {
  const { pathname } = useLocation();
  const { isAuthenticated } = useContext(AuthContext);
  const { planReady, canUseFeature } = useUserPlan();
  const feature = resolveFeatureForPath(pathname);

  if (!isAuthenticated || !feature) {
    return children;
  }

  if (!planReady) {
    return <div className="loading-spinner" aria-label="Loading plan" />;
  }

  if (!canUseFeature(feature)) {
    return <PlanUpgradeNotice feature={feature} />;
  }

  return children;
}
